import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { t } from '@lib/translation/helpers/translation.helper';

@Injectable({ providedIn: 'root' })
export class SnPasswordAPI {
  public rules: string[] = [];

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
  ) {}

  public setPassword(currentPassword: string, newPassword: string): Observable<Object> {
    return this._httpClient.post('/api/auth/password/set/', {
      password: currentPassword,
      newPassword,
    });
  }

  public resetPasswordLink(email: string): Observable<Object> {
    return this._httpClient.post('/api/auth/password/reset/', { email });
  }

  public resetPasswordToken(confirmData: Object): Observable<Object> {
    return this._httpClient.post('/api/auth/password/reset/verify-token/', confirmData).pipe(
      switchMap((response: any) => {
        return this._httpClient
          .get<string[]>('/api/auth/password/rules/', { params: { email: response.email } })
          .pipe(
            tap((results: string[]) => {
              this.rules = results;
            }),
            switchMap(() => of(response)),
          );
      }),
      tap({
        error: () => this._toastrService.error(t('account.dialogs.changePassword.verifyTokenFailed')),
      }),
    );
  }

  public resetPasswordConfirm(confirmData: Object): Observable<Object> {
    return this._httpClient.post('/api/auth/password/reset/confirm/', confirmData);
  }

  public changePassword(confirmData: Object): Observable<Object> {
    return this._httpClient.post('/api/auth/password/change/', confirmData).pipe(
      tap({
        next: () => this._toastrService.success(t('account.dialogs.changePassword.passwordChangedSuccessfully')),
        error: () =>
          this._toastrService.error(t('account.dialogs.changePassword.changeFailed')),
      }),
    );
  }

  public getPasswordRules(email: string): Observable<string[]> {
    return this._httpClient.get<string[]>('/api/auth/password/rules/', { params: { email } }).pipe(
      tap((results: string[]) => {
        this.rules = results;
      }),
    );
  }
}
